import { useEffect } from "react";

type TextHighlighterProp = {
  searchValue: string;
  textContent: string;
  id: string;
};

function TextHighlighter(props: TextHighlighterProp): JSX.Element {
  const { searchValue, textContent, id } = props;

  useEffect(() => {
    const frame = document.getElementById(id);
    if (searchValue !== "") {
      const regex = new RegExp(searchValue, "gi");

      const highlightedText = textContent.replace(
        regex,
        '<mark class="highlight">$&</mark>'
      );

      if (frame) {
        frame.innerHTML = highlightedText;
      }
    } else if (frame) {
      frame.innerHTML = textContent;
    }
  }, [searchValue]);

  useEffect(() => {
    const frame = document.getElementById(id);
    if (frame) {
      frame.innerHTML = textContent;
    }
  }, []);

  return (
    <div className="w-full" id={id}>
      <div>.</div>
    </div>
  );
}

export default TextHighlighter;
